import { AxiosResponse } from 'axios';

import axiosInstance from 'api/base';
import { normalizeBaseGist, normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { prepareFormData } from 'utils/form';
import { IAllPageFilters, IBaseGist, IPageType } from 'utils/types';

import { normalizePaymentLink } from './normalizers';
import { IPaymentLink, IPaymentLinkData, IPaymentLinkForm } from './types';

const paymentLinksAPI = {
  async getPaymentLinks(filters: IAllPageFilters): Promise<IPageType<IPaymentLink>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const response = await axiosInstance.get(`payment-links`, {
      params: normalizedFilter,
    });

    return normalizePageData<IPaymentLinkData, IPaymentLink>(
      response.data,
      normalizePaymentLink,
      JSON.stringify(filters.search),
    );
  },

  async getPaymentLink(id: number | string): Promise<IPaymentLink> {
    const response = await axiosInstance.get(`payment-links/${id}`);

    return normalizePaymentLink(response.data);
  },

  async createPaymentLink(payload: IPaymentLinkForm): Promise<IBaseGist> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.post(`payment-links`, normalizedPayload);

    return normalizeBaseGist(response.data);
  },

  async updatePaymentLink({ id, ...payload }: IPaymentLinkForm): Promise<IBaseGist> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.put(`payment-links/${id}`, normalizedPayload);

    return normalizeBaseGist(response.data);
  },

  async deletePaymentLink(id: number): Promise<AxiosResponse> {
    const response = await axiosInstance.delete(`payment-links/${id}`);

    return response.data;
  },
};

export default paymentLinksAPI;
